import React, { useEffect, useState } from "react";
import TopNavBar from "./TopNavBar";
import Sidebar from "./Sidebar";
import SubNavigationBar from "./SubNavigationBar";
import "../styles/AppLayout.css";

function AppLayout({ children }) {
  const user = JSON.parse(localStorage.getItem("user"));
  const role = localStorage.getItem("userRole");
  const isAdmin = role === "1" || user?.role === "admin";

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const closeSidebar = () => setSidebarOpen(false);

  useEffect(() => {
    const root = document.documentElement;
    const topNav = document.querySelector(".top-nav-bar");
    const subnav = document.querySelector(".subnav-container");

    const updateHeights = () => {
      const topNavHeight = topNav?.offsetHeight || 56;
      const subnavHeight = isAdmin && subnav ? subnav.offsetHeight : 0;
      root.style.setProperty("--top-nav-height", `${topNavHeight}px`);
      root.style.setProperty("--subnav-height", `${subnavHeight}px`);
    };

    updateHeights();

    const observer = new ResizeObserver(() => updateHeights());
    if (topNav) observer.observe(topNav);
    if (subnav) observer.observe(subnav);

    window.addEventListener("resize", updateHeights);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", updateHeights);
    };
  }, [isAdmin, sidebarOpen]);

  return (
    <>
      <TopNavBar onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
      {isAdmin && <SubNavigationBar sidebarOpen={sidebarOpen} user={user} />}

      <div style={{ display: "flex" }}>
        {isAdmin && sidebarOpen && (
          <button
            type="button"
            className="sidebar-backdrop"
            aria-label="Close sidebar"
            onClick={closeSidebar}
          />
        )}
        {isAdmin && <Sidebar isOpen={sidebarOpen} />}
        <div
          className={`app-layout-content ${isAdmin ? "with-admin-subnav" : ""}`}
          style={{
            marginLeft: isAdmin && sidebarOpen ? "180px" : "0px",
          }}
        >
          {children}
        </div>
      </div>
    </>
  );
}

export default AppLayout;
